module.exports = __webpack_public_path__ + "static/media/snowboarding.42fbb53c.jpg";